import {
  EuiButtonEmpty,
  EuiButtonEmptyProps,
  EuiButtonIcon,
} from "@inscopix/ideas-eui";
import { Tooltip } from "components/Tooltip/Tooltip";
import { Tool, ToolVersion } from "graphql/_Types";
import { useToolSpecContext } from "providers/ToolSpecProvider/ToolSpecProvider";

interface ButtonToolDocsProps {
  tool: {
    key: Tool["key"];
    version?: ToolVersion["version"];
  };
  iconSize?: EuiButtonEmptyProps["iconSize"];
  size?: EuiButtonEmptyProps["size"];
  iconType?: EuiButtonEmptyProps["iconType"];
  EuiButtonComponent?: typeof EuiButtonEmpty | typeof EuiButtonIcon;
}

export const ButtonToolDocs = ({
  iconType = "documentation",
  tool,
  iconSize = "m",
  size = "s",
  EuiButtonComponent = EuiButtonIcon,
}: ButtonToolDocsProps) => {
  const { docsMap } = useToolSpecContext();

  // It first tries to find a URL specific to the version of the tool being used.
  // If that doesn't exist, it tries to find the default doc URL for the tool.
  const docsUrl = (() => {
    const defaultUrl = docsMap[tool.key]?.default;
    const toolVersionUrl =
      tool.version !== undefined
        ? docsMap[tool.key]?.[tool.version]
        : undefined;
    return toolVersionUrl ?? defaultUrl;
  })();

  if (docsUrl === undefined) {
    return null;
  }

  return (
    <Tooltip content="Open documentation in new tab">
      <EuiButtonComponent
        onClick={(e: { stopPropagation: () => void }) => {
          e.stopPropagation();
        }}
        iconSize={iconSize}
        size={size}
        key="tool-docs-button"
        data-test-subj="tool-docs-button"
        aria-label="View documentation"
        iconType={iconType}
        href={docsUrl}
        target="_blank"
      >
        Documentation
      </EuiButtonComponent>
    </Tooltip>
  );
};
